import { routeHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export const Route = createFileRoute("/privacy-policy")({
  head: () => routeHead('Privacy Policy — AGAPE', 'Read how AGAPE protects and processes personal data.', '/privacy-policy'),
  component: PrivacyPolicy,
});
